/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_transfer_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud_transfer_medium_svg__a)">
      <path
        fill="#000"
        d="m5.066 7.087.14.737-.14-.737Zm13.872 1.925-.742-.11a.75.75 0 0 0 .8.858l-.058-.748ZM8.126 8.32a.75.75 0 1 0 .748-1.3l-.748 1.3ZM1.86 15.99a.75.75 0 0 0 1.08-1.04l-1.08 1.04Zm18.25.146a.75.75 0 1 0 .396 1.447l-.396-1.447ZM7.5 23A.75.75 0 0 0 9 23H7.5Zm3.22-4.97a.75.75 0 1 0 1.06-1.06l-1.06 1.06ZM8.25 14.5l.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-3.53 2.47a.75.75 0 1 0 1.06 1.06l-1.06-1.06ZM16.5 14.5a.75.75 0 0 0-1.5 0h1.5Zm-3.22 4.97a.75.75 0 1 0-1.06 1.06l1.06-1.06ZM15.75 23l-.53.53a.75.75 0 0 0 1.06 0l-.53-.53Zm3.53-2.47a.75.75 0 1 0-1.06-1.06l1.06 1.06ZM1.75 12a4.252 4.252 0 0 1 3.456-4.176L4.927 6.35A5.752 5.752 0 0 0 .25 12h1.5Zm4.062-4.828C6.195 3.822 9.184 1.75 12 1.75V.25c-3.456 0-7.195 2.528-7.679 6.752l1.49.17ZM12 1.75c4.143 0 6.7 3.737 6.196 7.153l1.484.218C20.3 4.913 17.17.25 12 .25v1.5Zm6.995 8.01C20.85 9.617 22.5 11.137 22.5 13H24c0-2.741-2.399-4.946-5.12-4.736l.115 1.496ZM5.205 7.824a4.301 4.301 0 0 1 2.921.496l.748-1.3a5.801 5.801 0 0 0-3.947-.67l.279 1.474ZM2.94 14.948A4.233 4.233 0 0 1 1.75 12H.25a5.73 5.73 0 0 0 1.609 3.989l1.08-1.04ZM22.5 13a3.252 3.252 0 0 1-2.39 3.135l.395 1.447A4.752 4.752 0 0 0 24 13h-1.5Zm-10.72 3.97-3-3-1.06 1.06 3 3 1.06-1.06Zm-4.06-3-3 3 1.06 1.06 3-3-1.06-1.06Zm4.5 6.56 3 3 1.06-1.06-3-3-1.06 1.06Zm4.06 3 3-3-1.06-1.06-3 3 1.06 1.06ZM15 14.5V23h1.5v-8.5H15ZM9 23v-8.5H7.5V23H9Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_transfer_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_transfer_medium
